/**
 * Formate un nombre en chaîne de caractères représentant une devise.
 * @param amount Le montant numérique.
 * @param currencyCode Le code de devise ISO 4217 (ex: 'EUR', 'USD').
 * @param locale La locale à utiliser pour le formatage (ex: 'fr-FR', 'en-US'). Utilise la locale du navigateur par défaut.
 * @returns Une chaîne formatée représentant le montant dans la devise.
 */
export const formatCurrency = (
    amount: number | null | undefined,
    currencyCode: string = 'EUR', // Défaut EUR
    locale: string | undefined = undefined // Défaut de Intl.NumberFormat
): string => {
    if (amount === null || amount === undefined || isNaN(amount)) {
        return '--'; // Ou une autre chaîne pour indiquer une valeur invalide/manquante
    }

    try {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyCode,
            // minimumFractionDigits: 2, // Optionnel: forcer 2 décimales
            // maximumFractionDigits: 2, // Optionnel: forcer 2 décimales
        }).format(amount);
    } catch (error) {
        console.error(`Error formatting currency:`, error);
        // Retourner une valeur par défaut en cas d'erreur (ex: code devise invalide)
        return `${amount.toFixed(2)} ${currencyCode}`;
    }
}; 